import { render, staticRenderFns } from "./UserStatsLayout1.vue?vue&type=template&id=eedbe924&"
import script from "./UserStatsLayout1.vue?vue&type=script&lang=js&"
export * from "./UserStatsLayout1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports